// extracted by mini-css-extract-plugin
module.exports = {"imgDiv":"imgDiv--kqqKZ","btns":"btns--ukUTB"};